<template>
  <div class="container mt-4">
    <b-navbar type="dark" variant="info" sticky>
      <b-navbar-brand href="#">Order History</b-navbar-brand>

      <b-navbar-nav class="ml-auto">

        <b-nav-form class="m-1 d-none d-sm-block">
          <!-- <b-button size="sm" class="my-2 my-sm-0" variant="primary" v-on:click="AddToCart" :disabled="HasInvalidQty || orderCount < 1">
            <template v-if="orderCount < 1">Please input your required quantities below.</template>
            <template v-else-if="HasInvalidQty">One of your product has an invalid quantity.</template>
            <template v-else>Add <b-badge variant="light">{{orderCount}}</b-badge> products to cart</template>
          </b-button> -->
        </b-nav-form>

      </b-navbar-nav>
    </b-navbar>

    <!-- <h3>Order History</h3> -->
    <b-row>
      <b-col>
        <b-row v-if="NoProductsFound">
          <b-col>
            <b-alert show variant="danger">No products found.</b-alert>
          </b-col>
        </b-row>
        <b-row v-if="!products">
          <b-col>
            <b-alert show variant="info">Loading....</b-alert>
          </b-col>
        </b-row>

        <div v-if="products">
          <b-row>
            <b-col class="mt-2">
              <b-table striped hover :items="products" :fields="ProductFields">
                <template #cell(Image)="data">
                  <b-img thumbnail fluid :src="data.item.ImageLink || './static/NoImage.jpg'" alt="Thumbnail" width="100" height="100" />
                </template>
                <template #cell(ItemNumber)="data">
                <!-- <template slot="ItemNumber" slot-scope="data"> -->
                  <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
                </template>
                <template #cell(Name)="data">
                <!-- <template slot="Name" slot-scope="data"> -->
                  <span>{{ data.item.Name }}</span>
                </template>
                <template #cell(LastPurchased)="data">
                  <span>{{ data.item.LastPurchased | moment("dddd, MMMM Do YYYY")}}</span>
                </template>
                <template #cell(Quantity)="data">
                <!-- <template slot="Quantity" slot-scope="data"> -->
                  <div> 
                    <b-form-input :state="data.item.Qty > 0 ? ProductQtyValid(data.item) : null" :id="`QtyInput${data.index}`" type="number" v-model="data.item.Qty" @keyup.native.enter="OnQtyEnter(data)"/>
                    <b-form-text v-if="!ProductMeetsMin(data.item)">Minimum order quantity is {{data.item.QuantityMin}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsStepSize(data.item)">Must order in multiples of {{data.item.QuantityStepSize}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsMax(data.item)">Maximum order quantity is {{data.item.QuantityMax}}</b-form-text>
                  </div>
                </template>
                <template #cell(NumberOfUnits)="data">
                  <span>{{ data.item.CartonQuantity * data.item.Qty }}</span>
                </template>
                <template #cell(AddToCart)="data">
                  <b-btn @click="AddItemToCart(data.item)"><i class="fa fa-shopping-cart" aria-hidden="true"></i></b-btn>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <b-btn @click="AddAllToCart" ref="AddToCartBtn" :disabled="HasInvalidQty">Add All to Cart</b-btn>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ProductService from "../services/ProductService";
import store from "@/store.js";
import NProgress from "nprogress";
import ConfigService from "@/services/ConfigService";
import _ from 'lodash';

import ShowPrices from '@/mixins/ShowPrices';

function GetProducts(done) {
  debugger;
  const company = store.state.auth.company;
  ProductService.GetHistory(company.Oid)
    .then(response => {
      debugger;
      const products = response.data;
      //changed 06/02/2025 - ticket #3597
      //_.forEach(products, i=> i.Qty = 0);
      const sorted = _.orderBy(products, i=> i.LastPurchased, 'desc');
      const fitlered = _.filter(sorted, i => i.LastPurchased);
      done(null, fitlered);
      //done(null, products);
    })
    .catch(() => {
      debugger;
      done("unable to get products");
    });
}



// function GetProducts(done) {
//   var orderbyColumn = "SortPriority";

//   if (store.state.auth.userInfo) {
//     orderbyColumn = "ProductService.SortPriority";
//   }

//   ProductService.GetProducts('', orderbyColumn, 0, 1000)
//     .then(response => {
//       const products = response.data;

//       _.forEach(products, i=> i.Qty = 0);

//       const sorted = _.orderBy(products, i=> i.LastPurchased, 'desc');
//       const fitlered = _.filter(sorted, i => i.LastPurchased);

//       done(null, fitlered);
//     })
//     .catch(() => {
//       done("unable to get products");
//     });
// }

export default {
  name: "PreviousPurchaseProducts",
  props:{
  },
  data() {
    return {
      error: null,
      products: null,
      fetchingProducts: false
    };
  },
  computed: {
    orderCount(){
      return _.sumBy(this.products, i => Number(i.Qty));
    },
    ProductFields() {
      return [
        { key: 'Image'}, 
        { key: 'ItemNumber'}, 
        { key: 'Description' },
        { key: 'LastPurchased' },
        { key: 'CartonQuantity', label: 'Box Quantity' },
        { key: 'Quantity', label: 'Number of Boxes Required', class: "text-right"},
        { key: 'NumberOfUnits', label: 'Number of Units' },
        { key: 'AddToCart', label: 'Add to Cart' },
      ];
    },
    HasInvalidQty() {
      var itemsWithQty = _.filter(this.products, i => i.Qty > 0 && !this.ProductQtyValid(i));
      return itemsWithQty.length > 0;
    },
    NoProductsFound: function() {
      return this.products != null && this.products.length == 0;
    },
    company() {
      return this.$store.state.auth.company;
    },
  },
  beforeRouteEnter(to, from, next) {
    debugger;
    GetProducts((err, products) => {
      next(vm => vm.setData(err, products));
    });
  },
  beforeRouteUpdate(to, from, next) {
    debugger;
    this.products = null;
    GetProducts((err, products) => {
      this.setData(err, products);
      next();
    });
  },
  watch:{
    company(){
      this.products = null;
      GetProducts((err, products) => {
        this.setData(err, products);
      });
    },
  },
  methods: {
    GetProducts,
    setData(err, products) {
      debugger;
      if (err) {
        this.error = err.toString();
      } else {
        this.products = products;
      }
    },
    navigateToProduct(number) {
      this.$router.push({ name: "ProductDetail", query: { number: number } });
    },
    ProductMeetsMin(product){
      if(product.Qty > 0 && product.QuantityMin > 0) {
        return product.Qty >= product.QuantityMin;
      }
      return true;
    },
    ProductMeetsMax(product){
      if(product.Qty > 0 && product.QuantityMax > 0) {
        return product.Qty <= product.QuantityMax;
      }
      return true;
    },
    ProductMeetsStepSize(product){
      if(product.Qty > 0 && product.QuantityStepSize > 0) {
        return product.Qty % product.QuantityStepSize == 0;
      }
      return true;
    },
    ProductQtyValid(product) {
        if(product.Qty === null || product.Qty === undefined || product.Qty === "" || product.Qty <= 0) {
          return false;
        }
        if(!this.ProductMeetsMin(product) || 
          !this.ProductMeetsMax(product) || 
          !this.ProductMeetsStepSize(product)) {
            return false;
        }
        return true;
    },
    AddItemToCart(item) {
      this.$store.commit("AddToCart", item);
      item.Qty = 1;
      this.$toasted
        //.success("Added " + itemsWithQty.length + " products to Cart")
        .success("Added " + item.Name + " products to Cart")
        .goAway(3000);
    },
    AddAllToCart() {
      const totalQty = this.orderCount;
      var itemsWithQty = _.filter(this.products, i => i.Qty > 0);

      _.forEach(itemsWithQty, i=> {
        this.$store.commit("AddToCart", i);
        i.Qty = 0;
      });
      
      this.$toasted
        //.success("Added " + itemsWithQty.length + " products to Cart")
        .success("Added " + totalQty + " products to Cart")
        .goAway(3000);
    },
    OnQtyEnter(data) {
      if(data.index != this.products.length -1) {
        var target = document.getElementById(`QtyInput${data.index + 1}`)
        if(target) {
          target.focus();
        }
      }
      else {
        this.$refs.AddToCartBtn.focus();
      }
    }
  },
  components: {
  },
  mixins: [ShowPrices]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.card-img-top {
  height: 15vw;
  object-fit: scale-down;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviousPurchaseProducts.vue